import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

import s from './ImageSingleChoiceAnswerItem.scss';

export interface IImageSingleChoiceAnswerItemProps {
    option: IAnswerOption;
    onSelectOption: () => void;
}

export const ImageSingleChoiceAnswerItem = React.memo(
	({ option, onSelectOption }: IImageSingleChoiceAnswerItemProps): JSX.Element => {
		useStyles(s);

		if (!option) return null;

		return (
			<div className="sl-image-single-choice-item">
				<div
					className={`sl-image-single-choice-item__img ${option.status}`}
					onClick={onSelectOption}
				>
					<img src={option.data?.assetUrl} alt="item" />
				</div>
				<div className="sl-image-single-choice-item__text">
					{option.text}
				</div>
			</div>
		);
	},
);
